import React from 'react'

function PieChart ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 24 24'>
      <path d='M10.667,74.665a10.667,10.667,0,0,1,0-21.333H11.2V63.465H21.333V64A10.681,10.681,0,0,1,10.667,74.665Zm-.533-20.253a9.6,9.6,0,1,0,10.12,10.12H10.133Zm0,0' transform='translate(0 -50.665)' />
      <path d='M267.2,11.2H256V0h.533A10.681,10.681,0,0,1,267.2,10.667Zm-10.133-1.067h9.053a9.619,9.619,0,0,0-9.053-9.053Zm0,0' transform='translate(-243.2)' />
      <path d='M21.335,266.667H20.268v-9.6h-9.6V256H21.335Zm0,0' transform='translate(-10.135 -243.2)' />
    </svg>
  )
}

PieChart.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default PieChart
